// extracted by mini-css-extract-plugin
module.exports = {"dayItemContent":"HomeOfficeDayItem_dayItemContent__y_UYb","dayItemErrorMessage":"HomeOfficeDayItem_dayItemErrorMessage__3aa1f"};